import fetchNext from '@features/api/fetchNext';
class CacheService {
  private endpoints = {
    revalidatePath: () => `revalidatePath`
  };
  public async revalidatePath(path: string) {
    const method = 'POST';
    const {
      json
    } = await fetchNext(this.endpoints.revalidatePath(), {
      method,
      body: JSON.stringify({
        path
      })
    });
    return json;
  }
}
export default new CacheService();